define(['integration/quoteandbind/quickquote/SupportedLobModules'], (SupportedLobModules)=> {
    return angular.module('edge.quoteandbind.quickquote.app', SupportedLobModules);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/app.js
 **/